<template>
    <div class="">
        <b-overlay :show="showoverlay_list" rounded="sm">
                  

             <div v-if="loans.length>0">
                    <common-list :pageurl="this.$api_url" :checkbox="checkbox"  :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="loans" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list> 
            </div>
            <div v-else>
                <div v-if="show_loader" class="list-no-data">
                    <span class="d-block text-center">Looking for relevant data..</span>
                    <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="list-no-data">
                    Looks like there is no GF loan application to show.
                </div>
            </div>
        </b-overlay>


        <b-modal id="delete-modal" title="Are you sure you want to delete this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>


        <b-modal id="decline-modal" title="Are you sure you want to decline this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Decline <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('decline-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="unapprove-modal" title="Are you sure you want to unapprove this Loan ?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="pauseLoan(loan_entity_id)">Unapprove <span v-if="loading != ''"><img :src="this.$api_url+'/public/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('unapprove-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
            <gf-loan-form :pageurl="this.$api_url" :flg="flg" :employee_id="0" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" v-on:childToParent="getLoanData"></gf-loan-form>                  
        </b-modal>
        <b-modal id="bv-modal-gf-loan-transactions-wizard" size="lg" hide-footer v-bind:title="modal_title">
            <gf-loan-transactions-wizard :pageurl="this.$api_url" :employee_id="employee_id" :key="tx_popup_count" :loan_id="loan_id" ></gf-loan-transactions-wizard>                  
        </b-modal>
        
        <b-modal id="installment-modal" title="Installment Breakdown" hide-footer> 
        <div class="row table-head">
            <div class="col-sm-4 font-weight-bold py-2">
                Installment No.
            </div>                      
            <div class="col-sm-4 font-weight-bold py-2">
                Month
            </div>
            <div class="col-sm-4 font-weight-bold py-2">
                Amount
            </div>
        </div>
        <div class="row table-row hover-bg"  v-for="(row, index) in my_installments" :key="index">
            <div class="col-sm-4 py-2 align-items-center d-flex">                    
                <div :style="(row.status==3) ? styleA : styleB" >Installement #{{index+1}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">                    
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.month)}}</div>
            </div>
            <div class="col-sm-4 py-2 align-items-center d-flex" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.amount)}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

    </div>
</template>


<script>
    export default{
        
        mounted() {
            
        },
        props: ['pageurl', 'flg'],
        data(){            
            
            return {
                
                loans:[], 
                loan_id:'',
                employee_id:'',
                tx_popup_count:0,
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#009efb !important',
                my_installments:[],
                is_custom:'',
                is_status:'',             
                bank_names: [
                    { value: null, text: "--Select--" },
                ],  
                modal_title:'',
                count:'', 
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                default_tenure: [0,150,0],
                showoverlay_list : false,                          
                successmsg:'',
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                showoverlaymodal : false,
                show_loader:true,
                loan_entity_id:'',
                loan_update_status:'',
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Declined" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approved" },
                    { value: "3", text: "Pause/Stopped" },
                    { value: "4", text: "Returned" },
                ],
                 /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                loans:[],   
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "company_loan_id", text: "Loan ID",type: "text"},
                    { value: "loan_amount", text: "Amount",type: "number"},
                    { value: "effective_date_of_loan", text: " Effective Date",type: "date"},
                    { value: "deduction_start_month", text: "Deduction Start Month",type: "monthyear"},
                    { value: "loan_tenure", text: "Tenure Month(s)",type: "number"},
                    { value: "loan_status", text: "Status",type: "text"},
                ],
                primary_key:'id', 
                company_options:[],
                tmp_loans:[],
                /***Child Component property data */
            }
        },
        methods:{
            formatMoney: function(amount){
                var money = Number(amount);
                money = money.toLocaleString();
                if(money=='NaN')
                money = amount;
                else{
                if(money.indexOf(".")<0)
                money = money+".00";
                }
                return money;
            },  
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, ''); 
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            
            showDeclineModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 0;
            this.$bvModal.show('decline-modal');
            this.approvepass=''; 
            },

            showUnapproveModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.loan_update_status = 1;
            this.$bvModal.show('unapprove-modal');
            this.approvepass=''; 
            },
            showDeleteModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.$bvModal.show('delete-modal');
            this.approvepass=''; 
            },
            showLoanTransactions: function(loan_id,employee_id)
            { 
                this.loan_id = loan_id;
                this.employee_id = employee_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.$bvModal.show('bv-modal-gf-loan-transactions-wizard');
            },
            showInstallment: function(loan)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                let formData = new FormData();
                formData.append('loan_id', loan);        
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url+'/gf/loan/installments', formData)
                .then(function (response) 
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');
                        
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            pauseLoan: function(pageflg)
            {
                
                this.loading='load'; 
                var update_status = this.loan_update_status;
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                formData.append('status', update_status); 
                axios.post(this.$api_url+'/gf/loan/loan-update-status', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal'); 
                        
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            deleteLoan: function(pageflg)
            {
                
                this.loading='load'; 
                let formData = new FormData();
                formData.append('loan_id', pageflg); 
                axios.post(this.$api_url+'/gf/loan/loan-delete', formData) 
                    .then(function (response) 
                    {    
                        this.$bvModal.hide('pause-modal'); 
                        this.$bvModal.hide('approve-modal');  
                        this.$bvModal.hide('decline-modal'); 
                        this.$bvModal.hide('unapprove-modal'); 
                        this.$bvModal.hide('delete-modal'); 
                        
                        this.loan_entity_id=''; 
                        this.loan_update_status = '';
                        this.loading='';   
                        this.getLoanData();
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
                            
            },
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.id > 0)
                    {

                        if(data.action_id == 0)
                        {
                            //this.showEmployeeDetails(data.id);
                        }
                        else if(data.action_id == 1)
                        {
                             this.editLoanInfo(data.id,0,0);
                        }
                        else if(data.action_id == 2)
                        {
                            this.editLoanInfo(data.id,1,0);
                        }
                        else if(data.action_id == 3)
                        {
                            this.showDeclineModal(data.id);
                        }
                        else if(data.action_id == 4)
                        {
                            this.editLoanInfo(data.id,0,3);
                        }
                        else if(data.action_id == 5)
                        {
                            this.editLoanInfo(data.id,0,2);
                        }
                        else if(data.action_id == 6)
                        {
                            this.showInstallment(data.id);
                        }
                        else if(data.action_id == 7)
                        {
                            this.editLoanInfo(data.id,0,1);
                        }
                        else if(data.action_id == 8)
                        {
                            this.showLoanTransactions(data.id);
                        }
                        else if(data.action_id == 9)
                        {
                            this.showDeleteModal(data.id);
                        }
                    }

                }
            },
            getLoanData: function()
            {
                this.loan_title = 'GF Application Lists';
                if(!this.checkNet()) return false;
                let currentObj = this; 
                currentObj.show_loader = true;
                
                axios.get(this.$api_url+'/gf/allloanapplications' , {
                    params: {
                    }
                }).then(function(response){
                     this.tmp_loans = response.data.employee_data;
                    this.company_options = response.data.options;
                    
                    if(this.tmp_loans.length > 0 )
                    {
                        this.tmp_loans.forEach(element => {
                                if(element.id > 0)
                                {
                                    element.loan_amount = this.formatMoney(element.loan_amount);
                                    let dop = []; 
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                    {
                                        dop = dop.concat([{ label: 'Approve' , value: 5 }]);
                                    }
                                    if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined'))
                                    {
                                        dop = dop.concat([{ label: 'Unapprove' , value: 7 }]);
                                    }
                                    if(element.has_tx==0  &&  (this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved'))
                                    {
                                        dop = dop.concat([{ label: 'Decline' , value: 3 }]);
                                    }
                                    if(element.has_tx==0  && (this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Declined' || this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Pause/Stopped'))
                                    {
                                        dop = dop.concat([{ label: 'Delete' , value: 9 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Approved')
                                    {
                                        dop = dop.concat([{ label: 'Pause / Stop' , value: 4 }]);
                                    }
                                    
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped'|| this.loan_stat_title[element.status] == 'Declined')
                                    {
                                        dop = dop.concat([{ label: 'Edit' , value: 1 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Approved')
                                    {
                                        dop = dop.concat([{ label: 'Manual Payment' , value: 2 }]);
                                    }
                                    if(this.loan_stat_title[element.status] == 'Applied' || this.loan_stat_title[element.status] == 'Approved' || this.loan_stat_title[element.status] == 'Pause/Stopped')
                                    {
                                        dop = dop.concat([{ label: 'Installments' , value: 6 }]);
                                    }
                                    
                                    
                                    dop = dop.concat([{ label: 'Transactions' , value: 8 }]);

                                    element.actions = dop;
                                }
                            });
                        
                    }
                    this.$bvModal.hide('bv-modal-loan');
                    this.loans = this.tmp_loans;
                    this.list_key = this.list_key + 1;
                    
                    currentObj.show_loader = false;
                }.bind(this)).catch(function (error){

                    currentObj.show_loader = false;
                    currentObj.serverError(error);
                    
                    });

            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/gf/loan/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            editLoanInfo(loan_id,is_custom,is_status)
            {
                this.modal_title = "Edit GF Loan";
                this.is_custom = is_custom;
                this.loan_id = loan_id;
                this.is_status = is_status;
                this.count = this.count + 1;
                this.$bvModal.show('bv-modal-loan');
            }, 
        },
        created: function(){
            this.getLoanData();
            //this.updateTransactions();
        }
    }
</script>